import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scoped.css';

export default function Card({
  children = null,
  className = '',
  onClick = () => {},
}) {
  const classes = [styles.root, className].filter(Boolean).join(' ');

  return (
    <section className={classes} onClick={onClick}>
      {children}
    </section>
  );
}

Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

Card.defaultProps = {
  children: null,
  className: '',
  onClick: () => {},
};
